import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Loader2, AlertCircle } from 'lucide-react';

import useDrive from './hooks/useDrive';
import { getApplication } from '../../services/application';
import { buildDriveItemsFromPdfArray } from './utils/buildDriveItems';

import Toolbar from './components/Toolbar/Toolbar';
import Explorer from './components/Explorer/Explorer';
import PreviewDrawer from './components/Preview/PreviewDrawer';

import { DriveWrapper, DriveContainer, Header, Title, Content } from './drive.styles';
import { EmptyState } from '../Dashboard/dashboard.styles';

const DriveContent = () => {
  const { id } = useParams();
  const { setItems, setFolderName, setApplicationId } = useDrive();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['application', id],
    queryFn: () => getApplication(id),
    enabled: Boolean(id),
  });

  useEffect(() => {
    setApplicationId(id ?? '');
  }, [id, setApplicationId]);

  useEffect(() => {
    if (!data) return;
    const app = data.list ?? data;
    setFolderName(app._id ?? '');
    setItems(buildDriveItemsFromPdfArray(app.pdfArray ?? []));
  }, [data, setItems, setFolderName]);

  if (isLoading) {
    return (
      <EmptyState>
        <Loader2 size={24} className="spin" />
        <span>Loading documents…</span>
      </EmptyState>
    );
  }

  if (isError) {
    return (
      <DriveWrapper>
        <DriveContainer>
          <AlertCircle size={15} />
          {error?.message || 'Failed to load documents.'}
        </DriveContainer>
      </DriveWrapper>
    );
  }

  return (
    <DriveWrapper>
      <DriveContainer>
        <Header>
          <div>
            <Title>Drive</Title>
          </div>
          <Toolbar />
        </Header>

        <Content>
          <Explorer />
          <PreviewDrawer />
        </Content>
      </DriveContainer>
    </DriveWrapper>
  );
};

export default DriveContent;
